<script setup lang="ts">
const store = useBigHeroBannerStore();
const count = computed(() => store.banners.length);
</script>

<template>
  <div
    v-if="store.status === LoadStatus.Ready"
    class="controls"
  >
    <div class="arrow-controls">
      <BigHeroBannerControlButton
        id="HeroBannerPreviousSlideButton"
        :title="$t('SV.LIT_PreviousSlide')"
        class="toggle-btn prev-btn"
        @click="store.goToPreviousSlide()"
      >
        <FAIcon class="fa-light fa-chevron-left" />
      </BigHeroBannerControlButton>
      <BigHeroBannerControlButton
        id="HeroBannerNextSlideButton"
        :title="$t('SV.LIT_NextSlide')"
        class="toggle-btn next-btn"
        @click="store.goToNextSlide()"
      >
        <FAIcon class="fa-light fa-chevron-right" />
      </BigHeroBannerControlButton>
    </div>
    <div class="bottom-controls">
      <BigHeroBannerControlButton
        v-if="!store.autoplay"
        id="HeroBannerAutoplayStartButton"
        :title="$t('SV.LIT_EnableAutoSlideRotation')"
        class="toggle-btn"
        @click="store.toggleAutoPlay()"
      >
        <FAIcon class="fa-solid fa-play" />
      </BigHeroBannerControlButton>
      <BigHeroBannerControlButton
        v-else
        id="HeroBannerAutoplayPauseButton"
        :title="$t('SV.LIT_PauseSlideRotation')"
        class="toggle-btn"
        @click="store.toggleAutoPlay()"
      >
        <FAIcon class="fa-solid fa-pause" />
      </BigHeroBannerControlButton>
      <div class="flex items-center gap-2">
        <BigHeroBannerDotButton
          v-for="(s, index) of count"
          :key="index"
          class="max-md:hidden"
          :index="index"
        />
      </div>
    </div>
  </div>
  <div
    v-else
    class="h-2 w-full"
  ></div>
</template>

<style scoped lang="postcss">
.prev-btn {
  @apply absolute left-5 top-[50%] z-10  -translate-y-3;
}
.next-btn {
  @apply absolute right-5 top-[50%] z-10 -translate-y-3;
}

.arrow-controls:deep() {
  button {
    @apply text-white transition-all;
    &:hover,
    &:focus-visible {
      @apply brightness-90;
    }
  }
}
.bottom-controls {
  @apply absolute bottom-0 left-0 right-0 z-10 flex items-center justify-between gap-4 px-3 text-center;
}

.bottom-controls:deep() {
  .dot {
    @apply scale-75 text-xs text-white opacity-25 transition-all;
    &.active {
      @apply scale-100 opacity-100;
    }
  }
  button:hover {
    @apply opacity-100;
  }

  .toggle-btn {
    @apply text-white hover:brightness-90 focus-visible:brightness-90;
  }
}
</style>
